import { Injectable, OnDestroy } from '@angular/core'
import { Gender } from 'src/app/models/gender'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { CodeListService } from './CodeListService'

@Injectable({
  providedIn: 'root',
})
export class GendersService extends CodeListService<Gender> implements OnDestroy {
  recordClass = Gender
  emptyGenderAdded = false

  public static MALE_ABBR = 'M'
  public static FEMALE_ABBR = 'F'

  constructor() {
    super()
  }

  public getAllWithAddedEmptyGender(): Observable<Gender[]> {
    if (!this.entity$) this.initObservable()

    return this.entity$.pipe(
      map((genders) => {
        if (!this.emptyGenderAdded) {
          this.emptyGenderAdded = true
          genders.unshift(Gender.createEmptyGender())
        }
        return genders
      }),
    )
  }

  getById(id: number) {
    return this.getAll().pipe(map((genders) => genders.find((gender) => id === gender.id)))
  }

  static getByIdFromSuppliedGenders(id: number, genders: Gender[]) {
    return genders.find((gender) => id === gender.id)
  }

  static isMaleByIdFromSuppliedGenders(id: number, genders: Gender[]) {
    if (!id) return false
    return this.getByIdFromSuppliedGenders(id, genders)?.abbr === 'M'
  }
  static isFemaleByIdFromSuppliedGenders(id: number, genders: Gender[]) {
    if (!id) return false
    return this.getByIdFromSuppliedGenders(id, genders)?.abbr === 'F'
  }
}
